import { PackingMaterialPricesColumns, PackingMaterialPricesRequest, PackingMaterialPricesResponseModel, ProductPackStyleReq,   } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import {  PackingMaterialPricesEntity } from "./packing-material-prices-entity";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { Product } from "../products/product.entity";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { SkuCodes } from "../sku-codes/sku-codes.entity";
import { PackingMaterialPricesLogs } from "./packing-material-prices-logs-entity";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@Injectable()

export class PackingMaterialPricesService{
    constructor(
        @InjectRepository(PackingMaterialPricesEntity) private repo: Repository<PackingMaterialPricesEntity>
    ){}
  
    async createPackingMaterialPrices(req : any): Promise<PackingMaterialPricesResponseModel> {
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            const columnArray = []
            const updatedArray = req.map((obj) => {
                const updatedObj = {}
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            })
            const difference = columnArray.filter((element) => 
            !PackingMaterialPricesColumns.includes(element));
            console.log(difference,"difference")
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new PackingMaterialPricesResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === "") {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            for (const rec of convertedData) {
                const product = await transactionManager.getRepository(SkuCodes).findOne({where:{shortCode:rec.Product}})
                const packStyle = await transactionManager.getRepository(PackingMethod).findOne({where:{packingMethodName:rec.PackStyle}})

                console.log(product,'productttttttttttttt');
                
                const existingData = await transactionManager.getRepository(PackingMaterialPricesEntity).findOne({ where:{ productId:{skuCodeId:product.productId},packingStyleId:{packingMethodId:packStyle.packingMethodId}} ,relations:['productId','packingStyleId']});
    
                if (existingData) {
                    // existingData.price = rec.Price;
                    const updatedData = await transactionManager.getRepository(
                        PackingMaterialPricesEntity
                    ).update({id:existingData.id},{price:rec.Price});
                    
                    if (updatedData.affected) {
                        const logs = new PackingMaterialPricesLogs()
                        logs.PackingMaterialPricesId = new PackingMaterialPricesEntity()
                        logs.PackingMaterialPricesId.id = existingData.id
                        logs.effectiveFrom = existingData.createdAt
                        logs.price = existingData.price
                        // logs.productId = new Product()
                        logs.createdUser = existingData.createdUser
                        // logs.PackingMaterialPricesId = existingData.id
                         const dataaaaaaa =   await transactionManager.getRepository(PackingMaterialPricesLogs).save(logs);
                         
                        flag.add(true);
                        // await transactionManager.releaseTransaction()
                    } 
                } else {
                    const product = await transactionManager.getRepository(SkuCodes).findOne({where:{shortCode:rec.Product}})
                    const packStyle = await transactionManager.getRepository(PackingMethod).findOne({where:{packingMethodName:rec.PackStyle}})
                    const entity = new PackingMaterialPricesEntity()
                                    entity.createdUser = req.createdUser
                                    entity.updatedUser = req.updatedUser
                                    // entity.category = data.Category
                                    entity.productId = new SkuCodes()
                                    entity.productId.skuCodeId = product.productId
                                    entity.packingStyleId = new PackingMethod()
                                    entity.packingStyleId.packingMethodId = packStyle.packingMethodId
                                    entity.price = rec.Price
                    
                    const savedData = await transactionManager.getRepository(PackingMaterialPricesEntity).save(entity);
    
                    if (savedData) {
                        flag.add(true);
                    } else {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new PackingMaterialPricesResponseModel(false, 0, 'Something went wrong in saving new data');
                    }
                }
            }
        
        if (!flag.has(false)) {
                        await transactionManager.completeTransaction();
                        return new PackingMaterialPricesResponseModel(true, 1, 'Data saved successfully');
                    } else {
                        await transactionManager.releaseTransaction();
                        return new PackingMaterialPricesResponseModel(false, 0, 'Something went wrong');
                    }
                } catch (err) {
                    console.log(err);
                    
            await transactionManager.releaseTransaction();
            return new PackingMaterialPricesResponseModel(false, 0, 'Something went wrong');
        }
    }
 
    async getAllPackingMaterialPricesInfo(): Promise<PackingMaterialPricesResponseModel> {
        try {
            let res = []
            const info = await this.repo.find({relations:['productId','packingStyleId']})
            console.log(info,'ppppppppp');
            
            if (info.length>0) {
                for(const data of info ){
                    res.push(new PackingMaterialPricesRequest(data.id,data.productId.productId,data.packingStyleId.packingMethodId,data.price,data.createdUser,data.updatedUser,data.packingStyleId.packingMethodName,data.productId.shortCode,data.isActive,data.versionFlag,data.updatedAt))
                }
                return new PackingMaterialPricesResponseModel(true, 1,'Data retrieved',res)
            } else {
                return new PackingMaterialPricesResponseModel(false, 0,'No data found')
            }
        } catch (err) {
            return new PackingMaterialPricesResponseModel(false, 0, 'Something went wrong', err)
        }
    }

    async getPriceAgainstProductPackStyle(req:ProductPackStyleReq):Promise<CommonResponse>{
        try{
            const data = await this.repo.find({where:{productId:req.productId,packingStyleId:req.packStyleId}})
            if(data.length > 0){
                return new CommonResponse(true,1,'Data retrieved',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }
}